module.exports = __webpack_public_path__ + "static/media/Bettdecke_100x135_Kissen_60x40.f7bd8ea8.png";